import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ConfigModule } from 'lib-config';

import { ShowPermittedDirective } from './directives/show-permitted.directive';
import { IsAdminGuard } from './guards/is-admin.guard';
import { HasApplicationRoleGuard } from './guards/has-application-role.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthorizationWithCredentialsInterceptor } from './interceptors/authorization-with-credentials.interceptor';
import { SilentRenewService } from './services/silent-renew.service';
import { AutoLoginGuard } from './guards/auto-login.guard';
import { OidcSecurityService } from './services/oidc-security.service';

@NgModule({
  declarations: [ShowPermittedDirective],
  providers: [
    ConfigModule,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationWithCredentialsInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      deps: [SilentRenewService],
      useFactory: (provider: SilentRenewService) => () => provider.startNew(),
      multi: true
    },
    AutoLoginGuard,
    IsAdminGuard,
    HasApplicationRoleGuard,
    OidcSecurityService
  ],
  exports: [ShowPermittedDirective]
})
export class AuthenticationModule { }
